import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Autocomplete from 'react-autocomplete';
import API from '../../apiService.js';
import ALERT from '../component/Alert';

const SignupSchema = Yup.object().shape({
  icd: Yup.string().required('ICD HARUS DIISI')
});

export default class Assesment extends Component {
  constructor(props) {
    super(props);
    // console.log(props.patient.id)
    this.state = {
      dataIcd: [{ id: '', code: '', nurse_diagnosis: '' }],
      icd: [
        {
          case: 'new',
          examination_type_id: '99',
          explanation: '',
          icd_code: '',
          id: '',
          nurse_code: {
            nurse_diagnosis: ''
          },
          visit_id: ''
        }
      ]
    };
    this.onChangeIcd = this.onChangeIcd.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.getItemValue = this.getItemValue.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.retrieveDataAsynchronouslyIcd = this.retrieveDataAsynchronouslyIcd.bind(
      this
    );
  }
  componentDidMount() {
    if (this.props.patient.nurse_diagnosis[0]) {
      this.setState({
        icd: this.props.patient.nurse_diagnosis
      });
    }
  }

  postIcd = async e => {
    const diagnose = this.state.icd;
    const res = await API.post('/management/nurse_diagnosis/create', { diagnose });
    if (res.code === 200) {
      ALERT('success', 'Berhasil Menyimpan Data ');
      this.setState({ icd: res.data });
      setTimeout(
        function () {
          let parent = [];
          parent = { data: this.state.icd, param: 'nurse_diagnosis' };
          this.props.parentCallback(parent);
        }.bind(this),
        200
      );
      // console.log(res.data);
    } else {
      ALERT('error', 'gagal menyimpan data');
    }
    this.props.nextTab();
  };

  handleInputNameChangeIcd = idx => evt => {
    const val = evt.split('-', 2);
    // console.log(evt.target.value);
    const newIcd = this.state.icd.map((icd, sidx) => {
      if (idx !== sidx) return icd;
      return {
        visit_id: this.props.patient.id,
        case: 'new',
        examination_type_id: '99',
        explanation: '',
        icd_code: val[0],
        id: '',
        log: false,
        nurse_code: {
          nurse_diagnosis: val[1],
        },
      };
    });

    this.setState({ icd: newIcd });
    setTimeout(
      function () {
        let parent = [];
        parent = { data: this.state.icd, param: 'nurse_diagnosis' };
        this.props.parentCallback(parent);
      }.bind(this),
      200
    );
  };
  handleAddInput = x => evt => {
    this.setState({
      [evt.target.name]: x
    });
  };

  handleRemoveInputIcd = idx => evt => {
    this.setState({
      [evt.target.name]: this.state.icd.filter((s, sidx) => idx !== sidx)
    });
  };
  retrieveDataAsynchronouslyIcd = async e => {
    // console.log(e);
    const param = {
      keyword: { text: e },
      limit: 10,
      sort: 'desc'
    };
    const res = await API.post('management/nurse_code/read', param);
    if (res.code === 200) {
      this.setState({
        dataIcd: res.data.data
      });
    } else {
      console.error('Cannot load data from remote source');
    }
  };
  onChangeIcd = idx => evt => {
    // console.log(evt.target.value);
    const newIcd = this.state.icd.map((icd, sidx) => {
      if (idx !== sidx) return icd;
      return {
        visit_id: this.props.patient.id,
        case: 'new',
        examination_type_id: '99',
        explanation: '',
        icd_code: '',
        id: '',
        log: false,
        nurse_code: {
          nurse_diagnosis: evt.target.value,
        }
      };
    });

    this.setState({ icd: newIcd });

    /**
     * Handle the remote request with the current text !
     */
    const par = evt.target.value;
    if (evt.target.value.length > 2) {
      // setTimeout(event => {
      this.retrieveDataAsynchronouslyIcd(par);
      // }, 300);
      // console.log("The Input Text has changed to ", par);
    }
  };
  onSelect(val) {
    this.setState({
      value: val
    });
    const x = val.split('-', 2);
    console.log("Option from 'database' selected : ", x);
  }

  /**
   * Define the markup of every rendered item of the autocomplete.
   *
   * @param {Object} item Single object from the data that can be shown inside the autocomplete
   * @param {Boolean} isHighlighted declares wheter the item has been highlighted or not.
   * @return {Markup} Component
   */
  renderItem(item, isHighlighted) {
    return (
      <div
        key={item.id}
        style={{ background: isHighlighted ? 'lightgray' : 'white' }}
      >
        {item.id} - {item.code} - {item.nurse_diagnosis}
      </div>
    );
  }

  getItemValue(item) {
    // You can obviously only return the Label or the component you need to show
    // In this case we are going to show the value and the label that shows in the input
    // something like "1 - Microsoft"
    return `${item.code}-${item.nurse_diagnosis} - ${item.id}`;
  }
  render() {
    console.log(this.props.patient);
    console.log(this.state.icd[0].icd_code);

    return (
      <div>
        <Formik
          enableReinitialize
          initialValues={{
            icd: this.state.icd[0].icd_code
          }}
          validationSchema={SignupSchema}
          onSubmit={values => {
            this.postIcd();
            // same shape as initial values
            // console.log(values);
          }}
        >
          {({ values, errors, touched }) => (
            <Form>
              <div className="form-group row">
                <div className="col-md-5 ">
                  <label
                    htmlFor="example-text-input"
                    className="col-form-label col-form-label-sm"
                  >
                    Diagnosa
                  </label>
                  <button
                    type="button"
                    name="icd"
                    style={{ marginLeft: '2%' }}
                    onClick={this.handleAddInput(
                      this.state.icd.concat([
                        {
                          visit_id: this.props.patient.id,
                          case: 'new',
                          examination_type_id: '99',
                          explanation: '',
                          icd_code: '',
                          id: '',
                          log: false,
                          nurse_code: {
                            nurse_diagnosis: '',
                          }
                        }
                      ])
                    )}
                    className="btn btn-sm btn-primary"
                  >
                    Add
                  </button>
                </div>
                <div className="col-md-7">
                  {this.state.icd.map((icd, idx) => (
                    <div key={idx} className="form-group row">
                      <Autocomplete
                        inputProps={{
                          className: 'form-control form-control-sm',
                          placeholder: 'ketikkan minimal 3 huruf diagnosa'
                        }}
                        getItemValue={this.getItemValue}
                        items={this.state.dataIcd}
                        renderItem={this.renderItem}
                        value={
                          this.state.icd[idx].nurse_code.nurse_diagnosis
                            ? this.state.icd[idx].icd_code + this.state.icd[idx].nurse_code.nurse_diagnosis
                            : ''
                        }
                        onChange={this.onChangeIcd(idx)}
                        onSelect={this.handleInputNameChangeIcd(idx)}
                        menuStyle={{
                          borderRadius: '3px',
                          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                          background: 'rgba(255, 255, 255, 0.9)',
                          padding: '2px 0',
                          fontSize: '90%',
                          position: 'fixed',
                          overflow: 'auto',
                          zIndex: '100',
                          maxHeight: "110%", // TODO: don't cheat, let it flow to the bottom
                        }}
                        wrapperStyle={{
                          maxWidth: '91.66667%',
                          flex: '0 0 91.66667%',
                          overflow: "auto",
                          maxHeight: '300px'
                        }}
                      />

                      <button
                        className="btn btn-sm btn-danger"
                        style={{ maxWidth: '10%' }}
                        name="icd"
                        onClick={this.handleRemoveInputIcd(idx)}
                      >
                        -
                      </button>
                      {errors.icd && touched.icd ? (
                        <div style={{ color: 'red' }}>{errors.icd}</div>
                      ) : null}
                    </div>
                  ))}
                </div>
              </div>

              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}
